(function( $ ) {
    $.fn.myDatePicker = function()
    {
        let $el = $(this);
        $('<div class="div-for-picker"></div>').insertBefore($el);
        var $myparent = $el.prev();
        $myparent.append($el);
        $myparent.append('<i class="fa icon-picker fa-calendar"></i>');
        $el.attr('data-date-language','th-th');
        $el.datepicker({autoclose:true});
        $el.on('keypress',function(event){
            var key = event.keyCode || event.charCode;
            if( key == 8 || key == 46 ) return true;
            else return false;
        });
    };
}( jQuery ));
$('.datepicker').each(function(i,e){$(e).myDatePicker()});